import { resetRecentProducts } from "@/lib/recently-viewed";
import { qs, qsa, listen, toggle, contains, remove } from "@fluorescent/dom";

const selectors = {
  form: ".selectors-form",
  disclosureList: "[data-disclosure-list]",
  disclosureToggle: "[data-disclosure-toggle]",
  disclosureInput: "[data-disclosure-input]",
  disclosureOptions: "[data-disclosure-option]",
};

const classes = {
  listVisible: "disclosure-list--visible",
};

function has(list, selector) {
  return list.map(l => l.contains(selector)).filter(Boolean);
}

export default function Disclosure(node) {
  const form = qs(selectors.form, document);
  const disclosureList = qs(selectors.disclosureList, node);
  const disclosureToggle = qs(selectors.disclosureToggle, node);
  const disclosureInput = qs(selectors.disclosureInput, node);
  const disclosureOptions = qsa(selectors.disclosureOptions, node);
  const events = [
    listen(disclosureToggle, "click", handleToggle),
    listen(disclosureToggle, "focusout", handleToggleFocusOut),
    listen(disclosureList, "focusout", handleListFocusOut),
    listen(node, "keyup", handleKeyup),
    listen(document, "click", handleBodyClick),
  ];

  disclosureOptions.forEach(option =>
    events.push(listen(option, "click", submitForm))
  );

  function submitForm(evt) {
    evt.preventDefault();
    const { value } = evt.currentTarget.dataset;

    // Clear existing "recently viewed" since the
    // language or currency is no longer accurate
    resetRecentProducts();

    disclosureInput.value = value;
    form.submit();
  }

  function handleToggleFocusOut(evt) {
    const disclosureLostFocus = has([node], evt.relatedTarget).length === 0;

    if (disclosureLostFocus) {
      hideList();
    }
  }

  function handleListFocusOut(evt) {
    const childInFocus = has([node], evt.relatedTarget).length > 0;
    const isVisible = contains(disclosureList, classes.listVisible);

    if (isVisible && !childInFocus) {
      hideList();
    }
  }

  function handleKeyup(evt) {
    if (evt.which !== 27) return;
    hideList();
    disclosureToggle.focus();
  }

  function handleToggle(evt) {
    const ariaExpanded =
      evt.currentTarget.getAttribute("aria-expanded") === true;
    evt.currentTarget.setAttribute("aria-expanded", !ariaExpanded);
    toggle(disclosureList, classes.listVisible);
  }

  function handleBodyClick(evt) {
    const isOption = has([node], evt.target).length > 0;
    const isVisible = contains(disclosureList, classes.listVisible);

    if (isVisible && !isOption) {
      hideList();
    }
  }

  function hideList() {
    disclosureToggle.setAttribute("aria-expanded", false);
    remove(disclosureList, classes.listVisible);
  }

  return () => {
    events.forEach(unsubscribe => unsubscribe());
  };
}
